
import _ from 'underscore'
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import LevelModel from '../models/LevelModel'
import MapModelMixin from './mixins/MapModelMixin'

class LevelCollection extends Backbone.Collection {
  
  model(attrs, options) {
    return new LevelModel(attrs, options)
  }

  transition(properties, duration = 350, ease = 'cubic-in-out') {
    this.each(model => model.transition(properties, duration, ease))
    return this
  }

  translate(x, y) {
    this.each(model => model.translate(x, y))
    return this
  }

  scale(scale) {
    this.each(model => model.scale(scale))
    return this
  }

  hide() {
    this.each(model => model.hide())
    return this
  }

  show() {
    this.each(model => model.show())
    return this
  }

  opacity(opacity) {
    this.each(model => model.opacity(opacity))
    return this
  }

  data() {
    let retval = []
    this.each(model => retval.push(model.data()))
    return retval
  }

  facades() {
    return this.map(model => model.facade());
  }
}

Cocktail.mixin(LevelCollection, MapModelMixin)

export default LevelCollection
